import React from "react";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import MostrarOptimo from "../Mostrar/MostrarOptimo";
import imagenes from "../../assets/Imagenes";
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";
import "../../styles/index.css"


const Otras = () => {
	return (
		<>
			<Header />
			<section className="section-todas-pesnias">
			<img src={imagenes.op7} className="banner-todas-pestanias" alt="" />
			</section>

			
			<MostrarOptimo tipo="otros"/>
			<Footer />
	
		</>
	);
};

export default Otras;
